import React from "react";
import { Chip } from "@mui/material";
import PropTypes from "prop-types";

const SwitchStatusChip = ({ respuesta, categorizeResponse }) => {
  const getColorConfig = (type) => {
    const colors = {
      success: {
        color: "#2e7d32",
        bgColor: "#e8f5e9",
      },
      error: {
        color: "#d32f2f",
        bgColor: "#ffebee",
      },
      warning: {
        color: "#ed6c02",
        bgColor: "#fff3e0",
      },
      info: {
        color: "#0288d1",
        bgColor: "#e3f2fd",
      },
      default: {
        color: "#757575",
        bgColor: "#f5f5f5",
      },
    };

    return colors[type] || colors.default;
  };

  const responseType = categorizeResponse(respuesta);
  const { color, bgColor } = getColorConfig(responseType);

  return (
    <Chip
      label={respuesta || "Sin respuesta"}
      size="small"
      sx={{
        backgroundColor: bgColor,
        color: color,
        border: `1px solid ${color}33`,
        fontWeight: "medium",
        fontSize: "0.75rem",
        maxWidth: "150px",
        "& .MuiChip-label": {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        },
      }}
    />
  );
};

SwitchStatusChip.propTypes = {
  respuesta: PropTypes.string,
  categorizeResponse: PropTypes.func.isRequired,
};

SwitchStatusChip.defaultProps = {
  respuesta: "Sin respuesta",
};

export default SwitchStatusChip;
